// extracted by mini-css-extract-plugin
export var closeButton = "_lr-2";
export var closeButtonIcon = "_lr-3";
export var lightboxContent = "_lr-1";
export var lightboxOverlay = "_lr-0";